// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1ygvp","content":"styles_content__290Za","selectAll":"styles_selectAll__11Ojq"};